import React from "react"

function BriefcaseImage() {
    return (
        <div className="briefcaseImageWrapper">
            <div className="handleOuter">
                <div className="handleInner"></div>
            </div>
            <div className="briefcaseBody"></div>
        </div>
    )
}

export default BriefcaseImage